module.exports = __webpack_public_path__ + "static/media/passenger.10155cd4.svg";